import React, { useState } from 'react'
import classNames from 'classnames'
import Big from 'big.js'
import Modal from 'meinian-package/src/component/modal'
import Icon from 'meinian-package/src/component/icon'
import { serialNum, targetCategory } from 'view/common'
import styles from './index.module.less'

export default ({ taskItem, visible, onClose }) => {
  const [activeId, setActiveId] = useState(null)
  console.log('taskItem', taskItem.missionTargetList)

  return <Modal
    visible={visible}
    onClose={onClose}
    className={styles['task-condition-modal']}
    title={<div className={styles['task-condition-title']}>
      <div>任务完成情况</div>
      <div className="task-condition-sub-title">总体完成{new Big(taskItem.totalDonePercent).times(100).toFixed()}%</div>
    </div>}
  >
    <div className={styles['task-condition-content']}>
      {
         taskItem.missionTargetList.map((item, i) => <div className="task-condition-content-item" key={item.id}>
           <div className="task-condition-content-item-header" onClick={() => (activeId === item.id ? setActiveId(null) : setActiveId(item.id))}>
             <div className="df-center">
               <Icon type={`${activeId === item.id ? 'm-shouqi' : 'm-zhankai'}`} className="task-condition-content-item-header-icon" />
               <div className="task-serial-number">任务{serialNum(i)}</div>
               <div className="task-category">{targetCategory(item.gender, item.rootCategory, item.category)}</div>
             </div>
             <div className="df-center">
               <div className="task-total">{item.doneNum}/{item.targetNum}</div>
               <div className="task-ratio">完成{new Big(item.doneNum).div(item.targetNum).times(100).toFixed(2)}%</div>
             </div>
           </div>
           <div className={classNames('task-condition-content-item-table', { unfold: activeId === item.id })}>
             <table className="task-table">
               <thead className="task-thead">
                 <tr>
                   <td>成员</td>
                   <td style={{ width: '58px' }}>完成数量</td>
                   <td style={{ width: '70px' }}>占比</td>
                 </tr>
               </thead>
               <tbody className="task-tbody">
                 {item.targetCompleteDetail.map(it => <tr key={it.id}>
                   <td><div>{it.userName}</div></td>
                   <td><div>{it.personalDoneNum}</div></td>
                   <td><div>{new Big(it.personalDonePercent).times(100).toFixed(2)}%</div></td>
                 </tr>)}
               </tbody>
             </table>
           </div>
         </div>)
      }
    </div>
  </Modal>
}
